import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import mixpanel from "mixpanel-browser";

declare global {
  interface Window {
    __FEATURE_FLAGS__: {
      getFeatureFlags: () => Record<string, string>;
      isOnFeatureFlag: (feature: string) => boolean;
    };
  }
}



@Injectable({
  providedIn: "root",
})
export class MixpanelService {
  constructor() {
    mixpanel.init(environment.mixpanel, {
      persistence: "localStorage",
      debug: environment.env !== "production",
      record_idle_timeout_ms: 1800000,
      record_sessions_percent: 1,
      record_mask_text_selector: ""
    });
  }

  track(eventName: string, properties?: any) {
    mixpanel.track(eventName, properties);
  }

  identify(userId: string) {
    mixpanel.identify(userId);
  }

  alias(anonymousId: string, userId: string) {
    mixpanel.alias(userId, anonymousId);
  }

  reset() {
    mixpanel.reset();
  }

  setPeople(properties: any) {
    mixpanel.people.set(properties);
  }

  register(key: string, value: unknown) {
    mixpanel.register({ [key]: value });
  }

  bulkRegister(properties: Record<string, unknown>) {
    mixpanel.register(properties);
  }

  unregister(keys: string[]) {
    for (let key of keys) {
      mixpanel.unregister(key);
    }
  }
    
  get_property(key: string) {
    return mixpanel.get_property(key);
  }

  get instance() {
    return mixpanel;
  }

  getTestingGroup(testingNumber: number, testId: string, groupNames = ["A", "B"], percentages = null) {
    const input = `${testId}:${testingNumber}`;
    const FNV_PRIME = 16777619;
    const FNV_OFFSET_BASIS = 2166136261;
    
    let hash = FNV_OFFSET_BASIS;
    for (let i = 0; i < input.length; i++) {
      hash ^= input.charCodeAt(i);
      hash *= FNV_PRIME;
    }

    const normalized = Math.abs(hash >>> 0) % 100;
    
    if (!percentages) {
      const equalSplit = 100 / groupNames.length;
      percentages = Array(groupNames.length).fill(equalSplit);
    }
    
    let cumulative = 0;
    for (let i = 0; i < percentages.length; i++) {
      cumulative += percentages[i];
      if (normalized < cumulative) {
        return groupNames[i];
      }
    }
    return groupNames[groupNames.length - 1];
  }

  getFeatureFlags() {
    const ff = window.__FEATURE_FLAGS__;
    if(!ff) return {};
    return ff.getFeatureFlags();
  }

  isOnFeatureFlag(feature: string) {
    const ff = window.__FEATURE_FLAGS__;
    if(!ff) return false
    return ff.isOnFeatureFlag(feature)
  }

}